/**
 * Convert a string to camel case, 'fooBar'
 * @function string.camelCase
 * @param {String} str
 * @returns {String}
 */
export { default } from 'lodash/camelCase';
